/* tslint:disable */
/* eslint-disable */

/**
 * Вход по коду из SMS (POST /auth/v1/login/) - запасной способ к звонку
 * @export
 * @interface SmsLogin
 */
export interface SmsLogin {
  phone: string;
  code: string;
}

export function SmsLoginToJSON(value?: SmsLogin | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    phone: value.phone,
    code: value.code,
  };
}

/**
 * @export
 * @interface SmsLoginResponse
 */
export interface SmsLoginResponse {
  access: string;
  refresh: string;
  isNewUser: boolean;
}

export function SmsLoginResponseFromJSON(json: any): SmsLoginResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    access: json['access'],
    refresh: json['refresh'],
    isNewUser: json['isNewUser'],
  };
}
